import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    eventoId: 0,
    cliente: '',
    evento: '',

    etapas: [],
    // /* Paginacion */
    // paginaActual: 1,
    // registrosPorPagina: 10,
    // totalRegistros: 0,
    // totalPaginas: 0,
};

const mutations = {
    updateField,

    'INICIALIZAR_EVENTO' (state, eventoId) {
        state.eventoId = eventoId;
        state.cliente = '';
        state.evento = '';
    
        state.etapas = [];
        // state.paginaActual = 1;
        // state.registrosPorPagina = 10;
        // state.totalRegistros = 0;
        // state.totalPaginas = 0;
    },
    'SET_EVENTO' (state, evento) {
        state.cliente = evento.cliente;
        state.evento = evento.nombre;
    },
    'SET_ETAPAS' (state, etapas) {
        state.etapas = etapas;
    },
    // 'SET_PAGINATION'(state, params) {
    //     state.paginaActual = params.paginaActual;
    //     state.registrosPorPagina = params.registrosPorPagina;
    //     state.totalRegistros = params.totalRegistros;
    //     state.totalPaginas = params.totalPaginas;
    // },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, eventoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_EVENTO', eventoId);

            apiAxios.get(`eventos/${eventoId}/titulo`) 
                .then(res => {
                    commit('SET_EVENTO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getEtapas ( { commit } ) {
        return new Promise((resolve, reject) => {
            apiAxios.get(`eventos/${state.eventoId}/etapas`)
                .then(res => {
                    commit('SET_ETAPAS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    delete ( {}, params ) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`eventos/${params.eventoId}/etapas/${params.eventoEtapaId}/delete`)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}